module.exports = __webpack_public_path__ + "img/device-Information_2.a0efb921.png";